import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin(({vueApp: app}) => {
  const {env, release, sentry: {dsn}} = useAppConfig();

  if (!dsn) {
    return
  }

  const ignoreErrors = [
    '<no response> Load failed',
    '<no response> Failed to fetch',
    '<no response> signal is aborted without reason',
    '<no response> The operation was aborted',
    '<no response> Request signal is aborted',
    'The user aborted a request',
    'The operation was aborted',
    'TypeError: Load failed',
    'Fetch is aborted',
    'Failed to fetch dynamically imported module',
    'Importing a module script failed',
    'The operation was aborted due to timeout',
    'window.TelegramGameProxy.receiveEvent',
    '503 Service Unavailable',
    '404 Not Found',
  ];

  Sentry.init({
    app,
    dsn,
    environment: env || 'production',
    sendDefaultPii: true,
    integrations: [],
    sampleRate: 0.25,
    tracesSampleRate: 0,
    release: 'belarusborder-web@' + release,
    ignoreErrors,
  })
});
